import React, { useEffect, useState } from 'react';

const LoadingOverlay: React.FC = () => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const handler = (e: Event) => {
      const detail = (e as any).detail || {};
      const delta = typeof detail.delta === 'number' ? detail.delta : 0;
      setCount(prev => Math.max(0, prev + delta));
    };
    window.addEventListener('global-loading', handler);
    return () => window.removeEventListener('global-loading', handler);
  }, []);

  if (count <= 0) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 12,
      right: 12,
      zIndex: 1050,
      background: 'rgba(255,255,255,0.9)',
      boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
      borderRadius: 12,
      padding: '8px 12px',
      display: 'flex',
      alignItems: 'center',
      gap: 8
    }}>
      <span className="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true" />
      <span style={{ color: '#0d6efd', fontWeight: 600 }}>Cargando…</span>
    </div>
  );
};

export default LoadingOverlay;
